import React from 'react';
import { Route } from 'react-router-dom';

import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';

import UsersData from './DesignerPane/Users'


class PlatformUsers extends React.Component {

  componentWillMount() {
    dispatch.app.setCurrentContext("platform-user");
  }

  componentWillUnmount() {

  }

  render() {

    return (
      <div>
        <Route exact path="/app/platform/users" render={() => (<UsersData  {...this.props} />)} />
        <Route exact path="/app/platform/users/:tab" render={() => (<UsersData  {...this.props} />)} />
      </div>
    )
  }
}

function mapStateToProps(state) {

  return {
    user: state.app.user,
    selectedAccount: state.app.selectedAccount,
    addedAccountUser: state.invite.addedAccountUser,
    platformUsers: state.platform.platformUsers,
    platformUsersCount: state.platform.platformUsersCount,
    accountInvitedUser: state.account.accountInvitedUser,
  };
}

const connectedUsers = connect(mapStateToProps)(PlatformUsers);

export { connectedUsers as PlatformUsers };